// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Zatvori',
  error: () => 'Greška',
  warn: () => 'Upozorenje',
  info: () => 'Informacije',
  confirmation: () => 'Potvrda',
  progressIndeterminate: () => 'U toku',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nije pronađen nijedan podudaran odjeljak.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Pritisni Enter za izbor vrijednosti.',
  indexer_touchInstructionText: () =>
    'Dvaput dodirnuti i držati. Čekati na zvuk i onda prevući da bi se preuredilo.',
  inputPassword_show: () => 'Prikaži lozinku',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_hidden: () => 'Lozinka je skrivena',
  formControl_clear: () => 'Očisti',
  formControl_loading: () => 'Učitavanje',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Prekoračena je maksimalna dužina od ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostalo znakova: ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Unesi vrijednost.',
  select_requiredMessageDetail: () => 'Izaberi vrijednost.',
  select_noMatchesFound: () => 'Nije pronađeno nijedno podudaranje.',
  select_oneMatchFound: () => 'Pronađeno je jedno podudaranje',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađeno podudaranja: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađeno podudaranja: najmanje ' + p['TOTAL_SIZE'],
  selectMultiple_selectedValues: () => 'Izabrane vrijednosti',
  selectMultiple_showSelectedValues: () => 'Prikaži samo izabrane vrijednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Izabrano vrijednosti: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite Backspace ili Delete da uklonite izabrane vrijednosti.',
  selectMultiple_apply: () => 'Primijeni',
  selectMultiple_back: () => 'Nazad',
  selector_selected: () => 'Okvir je potvrđen',
  selector_unselected: () => 'Okvir nije potvrđen',
  userAssistance_learnMore: () => 'Saznaj više',
  userAssistance_required: () => 'Obavezno',
  filePicker_singleFileUploadError: () => 'Učitaj jednu po jednu datoteku',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete učitati datoteke vrste ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete učitati datoteke vrste ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  filePicker_dropzonePrimaryText: () => 'Povuci i ispusti',
  filePicker_dropzoneSecondaryText: () => 'Izaberi datoteku ili ispusti neku ovdje',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Izaberi ili ispusti datoteke ovdje',
  filePicker_addFiles: () => 'Dodaj datoteke',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Povećaj',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_converterParseError: () => 'Unesi broj.',
  noData_message: () => 'Nema stavki za prikaz',
  message_navigationFromMessagesRegion: () =>
    'Područje za unošenje poruka. Pritisnite F6 za povratak na prethodno fokusirani element.',
  message_navigationToMessagesRegion: () =>
    'Područje za poruke sadrži nove poruke. Pritisnite F6 za prelazak na područje s najnovijim porukama.',
  messageToast_allMessagesClosed: () => 'Sve toast poruke su zatvorene.',
  expandableList_groupCollapse: () => 'Sažeto',
  expandableList_groupExpand: () => 'Prošireno',
  expandableList_expandCollapseInstructionText: () =>
    'Koristi tipke sa strelicama za proširivanje i sužavanje',
  list_suggestion: () => 'Prijedlog',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_current: () => 'Trenutno',
  train_visited: () => 'Posjećeno',
  train_not_visited: () => 'Nije posjećeno',
  train_message_type: () => 'Vrsta poruke',
  viz_drillable: () => 'Raščlanjivo',
  dataVisualization_stateSelected: () => 'Izabrano',
  dataVisualization_stateUnselected: () => 'Nije izabrano',
  dataVisualization_noData: () => 'Nema podataka za prikaz'
};
export default bundle;
